// =============================================================================
// MeuDriver — Landing Page (orchestrator)
// -----------------------------------------------------------------------------
// As 8 seções foram extraídas para `./landing/`. Esta página só compõe.
// =============================================================================

import { useSEO } from '@/hooks/useSEO'
import { LandingHero } from './landing/LandingHero'
import { LandingStats, LandingHowItWorks } from './landing/LandingStatsHowItWorks'
import {
  LandingFeaturedInstructors,
  LandingSpecialties,
} from './landing/LandingFeaturedAndSpecialties'
import {
  LandingTestimonials,
  LandingCTA,
} from './landing/LandingTestimonialsAndCTA'
import { LandingFAQ } from './landing/LandingFAQ'

export default function LandingPage() {
  useSEO({
    title: 'Aulas de Direção Particulares com Instrutores Verificados',
    description:
      'O jeito mais fácil de aprender a dirigir. Encontre instrutores particulares verificados, agende aulas online e pague com segurança.',
  })

  return (
    <div className="min-h-screen bg-white">
      <LandingHero />
      <LandingStats />
      <LandingHowItWorks />
      <LandingFeaturedInstructors />
      <LandingSpecialties />
      <LandingTestimonials />
      <LandingCTA />
      <LandingFAQ />
    </div>
  )
}
